import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import { GlobalConstants } from "../../constants/GlobalConstants";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { useState } from "react";
import { Card } from "semantic-ui-react";
import "../../../styles/lms/lms-vendors-pages.scss";

const addMergeVendorsFormFields = (myForm) => {
  myForm.addCenteredGroup([myForm.getDropdownField("Deleted Vendor", "vendors/list-merge-organizations", { name: "fromOrgId", required: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Retained Vendor", "vendors/list-merge-organizations", { name: "toOrgId", required: true })]);
  return myForm;
};

const AddMergeVendorsForm = () => {
  const [htmlResponse, setHtmlResponse] = useState("");
  const onSubmitSuccess = (response) => {
    if (response && response.data) {
      setHtmlResponse(response.data);
    }
  };

  const myForm = addMergeVendorsFormFields(new BCFormController({}, { onSubmitSuccess }));
  const formActions = [
    {
      text: "Analysis",
      icon: GlobalConstants.Icons.EXCEL_OUTLINE,
      action: "submit",
      actionSubmitSuffix: "vendors/merge-organizations-analysis",
      actionSubmitMethod: "POST"
    },
    {
      text: "Process",
      icon: GlobalConstants.Icons.PDF_OUTLINE,
      action: "submit",
      actionSubmitSuffix: "vendors/process-merge-organizations",
      actionSubmitMethod: "POST"
    }
  ];

  return <>
    <LmsFormGenerator myForm={myForm} actions={formActions} />
    {htmlResponse && <Card centered fluid className="lms-vendors-merge-vendors-response-card-container">
      <div className="lms-vendors-merge-vendors-response-container" dangerouslySetInnerHTML={{ __html: htmlResponse }} />
    </Card>}
  </>;
};

const LmsVendorsMergeVendors = ({ params = {}, history }) => {
  const { isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
      history.goBack();
  }

  return (<AddMergeVendorsForm />);
};

export default LmsVendorsMergeVendors;